
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["setBaseUrl","setHeaders","fetchLeaderboard","fetchEntries","fetchQuestions","calculateQuestionsWithWinners"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "d42650ecac2d025636d1.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			